// DonutChart.tsx
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

interface DonutChartProps {
  principalAmount: number;
  interestAmount: number;
}

const DonutChart: React.FC<DonutChartProps> = ({
  principalAmount,
  interestAmount,
}) => {
  // Data for the donut chart
  const data = {
    labels: ["Principal", "Interest"],
    datasets: [
      {
        data: [principalAmount, interestAmount],
        backgroundColor: ["#0B2B4C", "#F37B2C"], // Green for Principal, Orange for Interest
        hoverBackgroundColor: ["#0B2B4C", "#F37B2C"],
        borderWidth: 2,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const, // TypeScript enforces this to be a string literal
        onClick: (e: any) => e.stopPropagation,
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => {
            return tooltipItem.label + ": ₹" + tooltipItem.raw.toLocaleString();
          },
        },
      },
      doughnut: {
        cutout: 50, // Creates the donut shape
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div style={{ width: "100%", height: "350px", margin: "0 auto" }}>
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DonutChart;
